import { formatSpecialization } from '@lighthouse/shared';

interface Props {
  specializations: string[];
  limit?: number;
}

export function TherapistSpecializationPills({ specializations, limit }: Props) {
  const visible = limit ? specializations.slice(0, limit) : specializations;
  const remaining = limit ? Math.max(0, specializations.length - limit) : 0;

  if (visible.length === 0) return <span className="text-xs text-gray-400">—</span>;

  return (
    <div className="flex flex-wrap items-center gap-1">
      {visible.map((spec) => (
        <span key={spec} className="spec-pill">
          {formatSpecialization(spec)}
        </span>
      ))}
      {remaining > 0 && <span className="text-xs font-medium text-gray-500">+{remaining}</span>}
    </div>
  );
}
